import { styled } from '@stitches/react'

export const SortableItemWrapper = styled('li', {
  display: 'flex',
  justifyContent: 'left',
  flexGrow: '1',
  alignItems: 'center',
  backgroundColor: '$tertiary-200',
  borderRadius: '$pill',
  boxSizing: 'border-box',
  listStyle: 'none',
  color: '$accent-black',
  fontWeight: '400',
  fontSize: '1rem',
  fontFamily: '$primary',
  textAlign: 'left',
  position: 'relative',
  userSelect: 'none',
  border: '1px solid $accent-red',
  padding: '$1',
})

export const DragHandleWrapper = styled('div', {
  display: 'flex',
  width: '12px',
  padding: '15px',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  touchAction: 'none',
  cursor: 'var(--cursor, grab)',
  borderRadius: '5px',
  border: 'none',
  outline: 'none',
  appearance: 'none',
  backgroundColor: 'transparent',
  ['-webkit-tap-highlight-color']: 'transparent',
  ['&:hover']: {},
  ['&:focus-visible']: {
    boxShadow: '0 0px 0px 2px #4c9ffe',
  },
  ['& svg']: {
    flex: '0 0 auto',
    margin: 'auto',
    height: '100%',
    overflow: 'visible',
    fill: '#919eab',
  },
})
